import { cn } from '@poseidon/components/cn';
import { type ComponentProps } from 'react';

export type NotificationLabelProps = ComponentProps<'div'> & {
  counterValue: number;
  gradient?: boolean;
  // The shake animation is driven from outside (see `useShakeOnChange` in
  // LeftNav) so this component renders purely from props.
  isShaking?: boolean;
};
const NotificationLabel = ({ className, counterValue, gradient, isShaking }: NotificationLabelProps) => {
  if (counterValue <= 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'min-w-5 absolute right-2 top-1/2 flex -translate-y-1/2 items-center justify-center rounded-full px-1.5 py-1 text-xs font-bold leading-none text-white',
        gradient ? 'bg-zumthor-900 dark:bg-zumthor-600' : 'bg-red-600',
        { 'animate-shakeX': isShaking },
        className,
      )}>
      {counterValue > 99 ? '99+' : counterValue}
    </div>
  );
};

export default NotificationLabel;
